(() => {
  if (window.gmkFastGiftCart) return;
  const configElement = document.getElementById('gmk-fast-gift-cart-config');
  if (!configElement) return;
  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch {
    return;
  }
  window.gmkFastGiftCart = true;
  document.querySelectorAll('form.gpr-form').forEach(form => {
    const id = String(new FormData(form).get('id') || '');
    if (config.variants[id]) form.closest('.gmk-product-information-v2')?.setAttribute('data-gmk-fast-gift-layout', '');
  });
  const forms = 'form.gpr-form, form.gmk-product-deals__button-form, form.gmk-flash-deals__button-form';
  const giftProperty = '_salepify-advanced-fg';
  let pending = false;

  function getOffer(productId, formData) {
    const app = window.tlFreeGiftOffer;
    if (!app?.isReady || !(app.ruleIdMapData instanceof Map)) return null;
    if (formData.get('selling_plan')) return null;
    const offer = config.offers.find(candidate => candidate.parents.includes(productId));
    const rule = offer && app.ruleIdMapData.get(offer.rule);
    if (!rule || !rule.active || !rule.auto_add_gift) return null;
    if (rule.module !== 'popup' || app.constants?.POPUP_PROPERTY !== giftProperty) return null;
    if (rule.apply_to_product !== 'product' || rule.apply_condition_type !== 'quantity') return null;
    if (Number(rule.apply_condition_value) !== 1 || rule.apply_condition_max_value != null) return null;
    if (rule.gift_type !== 'variant' || Number(rule.gift_qty) !== 1 || rule.is_gift_qty_fixed) return null;
    if (rule.maximum_per_order != null || rule.discount_usage_limit != null || rule.applies_once_per_customer) return null;
    if (rule.discount_type !== 'percentage' || Number(rule.discount_value) !== 100) return null;
    if (rule.customer_target !== 'all' || rule.country_target_value || rule.require_specific_qty) return null;
    if (rule.purchase_type !== 'one_time_purchase' || rule.sales_channels !== 'online_store') return null;
    if (!rule.discount_code || !Array.isArray(rule.listParents) || rule.listChilds?.length !== 1) return null;
    if (String(rule.listChilds[0].shopify_id) !== offer.gift) return null;
    const parents = rule.listParents.map(parent => String(parent.shopify_id));
    if (!parents.includes(productId) || parents.some(id => !offer.parents.includes(id))) return null;
    if (rule.listParents.some(parent => Number(parent.quantity) !== 0)) return null;
    const now = Date.now();
    if (rule.start_at && (!Number.isFinite(Date.parse(rule.start_at)) || Date.parse(rule.start_at) > now)) return null;
    if (rule.end_at && (!Number.isFinite(Date.parse(rule.end_at)) || Date.parse(rule.end_at) <= now)) return null;
    try {
      const conditions = JSON.parse(rule.advanced_conditions || '{}');
      if (Object.values(conditions).some(value => value !== null && value !== false && value !== '')) return null;
    } catch {
      return null;
    }
    if (app.ruleIdMapState?.get(rule.id)?.isStopped) return null;
    return { ...offer, parents, code: rule.discount_code };
  }

  function destinationFor(data) {
    const value = data.get('return_to');
    if (typeof value === 'string' && value.trim()) {
      try {
        const target = new URL(value, location.origin);
        if (target.origin === location.origin) return target.pathname + target.search + target.hash;
      } catch {}
    }
    return config.cart;
  }

  async function request(root, endpoint, body) {
    const response = await window.fetch(root + endpoint + '?app=salepify', {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const data = await response.json().catch(() => null);
    if (!response.ok || !data || Number(data.status) >= 400) {
      const message = data?.description || data?.message;
      throw new Error(typeof message === 'string' ? message : config.error);
    }
    return data;
  }

  function isOwnedGift(item, offer) {
    return String(item.variant_id || item.id) === offer.gift && String(item.properties?.[giftProperty]) === String(offer.rule);
  }

  function showError(form, message) {
    let error = form.querySelector('[data-gmk-fast-gift-error]');
    if (!error) {
      error = document.createElement('div');
      error.dataset.gmkFastGiftError = '';
      error.setAttribute('role', 'alert');
      form.appendChild(error);
    }
    error.replaceChildren(document.createTextNode(message + ' '));
    const link = document.createElement('a');
    link.href = config.cart;
    link.textContent = config.viewCart;
    error.appendChild(link);
    error.hidden = false;
  }

  window.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(forms)) return;
    if (event.submitter?.closest('.shopify-payment-button')) return;
    let action;
    try {
      action = new URL(form.action, location.origin);
    } catch {
      return;
    }
    if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) return;
    const data = new FormData(form);
    const id = String(data.get('id') || '');
    const productId = config.variants[id];
    if (!productId) return;
    const quantity = Number(data.get('quantity') || 1);
    if (!Number.isSafeInteger(quantity) || quantity < 1) return;
    if ([...data.values()].some(value => typeof value !== 'string')) return;
    const offer = getOffer(productId, data);
    if (!offer) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) return;
    pending = true;
    const destination = destinationFor(data);
    const root = (window.Shopify?.routes?.root || config.root || '/').replace(/\/?$/, '/');
    const properties = {};
    for (const [key, value] of data.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    }
    const controls = [...form.querySelectorAll('button[type="submit"], input[type="submit"]')].map(control => ({
      control, disabled: control.disabled, busy: control.getAttribute('aria-busy'), html: control.innerHTML, value: control.value
    }));
    controls.forEach(({ control }) => {
      control.disabled = true;
      control.setAttribute('aria-busy', 'true');
      if (control.tagName === 'INPUT') control.value = config.adding;
      else control.textContent = config.adding;
    });
    const previousError = form.querySelector('[data-gmk-fast-gift-error]');
    if (previousError) previousError.hidden = true;
    let mutationSent = false;
    try {
      const cart = await request(root, 'cart.js');
      if (!Array.isArray(cart.items) || !Array.isArray(cart.discount_codes)) throw new Error(config.error);
      const parentIds = new Set(offer.parents);
      const existingParents = cart.items.filter(item => parentIds.has(String(item.product_id)) && !item.selling_plan_allocation);
      const expectedGifts = existingParents.reduce((sum, item) => sum + item.quantity, quantity);
      const currentGifts = cart.items.filter(item => isOwnedGift(item, offer));
      const existingGiftQuantity = currentGifts.reduce((sum, item) => sum + item.quantity, 0);
      const missingGifts = Math.max(0, expectedGifts - existingGiftQuantity);
      const codes = [...new Set([...cart.discount_codes.map(discount => discount.code), offer.code])];
      if (codes.length > 5) throw new Error(config.error);
      if (!cart.discount_codes.some(discount => discount.code.toLowerCase() === offer.code.toLowerCase())) {
        await request(root, 'cart/update.js', { discount: codes.join(',') });
      }
      const items = [];
      if (missingGifts) items.push({ id: offer.gift, quantity: missingGifts, properties: { [giftProperty]: offer.rule } });
      items.push({ id, quantity, ...(Object.keys(properties).length ? { properties } : {}) });
      mutationSent = true;
      const added = await request(root, 'cart/add.js', { items });
      if (!Array.isArray(added.items)) throw new Error(config.error);
      const addedParentQuantity = added.items.filter(item => String(item.variant_id || item.id) === id).reduce((sum, item) => sum + item.quantity, 0);
      if (addedParentQuantity < quantity) throw new Error(config.error);
      const returnedGifts = missingGifts ? added.items.filter(item => isOwnedGift(item, offer)) : currentGifts;
      const returnedGiftQuantity = returnedGifts.reduce((sum, item) => sum + item.quantity, 0);
      if (!returnedGifts.length || returnedGiftQuantity < (missingGifts || expectedGifts)) throw new Error(config.error);
      const giftsAreFree = returnedGifts.every(item => item.final_line_price === 0);
      if (!giftsAreFree) {
        const updated = await request(root, 'cart/update.js', { discount: codes.join(',') });
        const verifiedGifts = updated.items?.filter(item => isOwnedGift(item, offer)) || [];
        const verifiedQuantity = verifiedGifts.reduce((sum, item) => sum + item.quantity, 0);
        if (verifiedQuantity < expectedGifts || !verifiedGifts.every(item => item.final_line_price === 0)) throw new Error(config.error);
      }
      location.assign(destination);
    } catch (error) {
      showError(form, error?.message || config.error);
      if (!mutationSent) {
        pending = false;
        controls.forEach(({ control, disabled, busy, html, value }) => {
          control.disabled = disabled;
          if (control.tagName === 'INPUT') control.value = value;
          else control.innerHTML = html;
          if (busy === null) control.removeAttribute('aria-busy');
          else control.setAttribute('aria-busy', busy);
        });
      }
    }
  }, true);
})();

